document.addEventListener('DOMContentLoaded', function() {

  // -------------------
  // Category → Subcategory → More
  // -------------------
  var categoryObject = document.getElementById('category');
  var subObject = document.getElementById('sub_category');
  var moreObject = document.getElementById('more_category');

  if(categoryObject && subObject && moreObject){

    var initCat  = categoryObject.dataset.init || '';
    var initSub  = subObject.dataset.init      || '';
    var initMore = moreObject.dataset.init     || '';

    function loadSub(catId, preselectSub, preselectMore) {
      subObject.innerHTML  = '<option selected value="">ไม่มี</option>';
      moreObject.innerHTML = '<option selected value="">ไม่มี</option>';
      if (!catId) return;
      fetch('sub_category.php?id_category=' + catId)
        .then(r => r.json())
        .then(results => {
          results.forEach(function(item) {
            var opt = document.createElement('option');
            opt.value = item.id;
            opt.textContent = item.category_name;
            if (preselectSub && String(item.id) === String(preselectSub)) opt.selected = true;
            subObject.appendChild(opt);
          });
          if (preselectSub) loadMore(preselectSub, preselectMore);
        });
    }

    function loadMore(subId, preselectMore) {
      moreObject.innerHTML = '<option selected value="">ไม่มี</option>';
      if (!subId) return;
      fetch('sub_category.php?id_category=' + subId)
        .then(r => r.json())
        .then(results => {
          results.forEach(function(item) {
            var opt = document.createElement('option');
            opt.value = item.id;
            opt.textContent = item.category_name;
            if (preselectMore && String(item.id) === String(preselectMore)) opt.selected = true;
            moreObject.appendChild(opt);
          });
        });
    }

    // เปลี่ยนหมวดหลัก — ถ้ากลับมาค่าเดิมให้ restore หมวดรอง/ย่อยด้วย
    categoryObject.addEventListener('change', function () {
      var isOriginal = initCat && String(this.value) === String(initCat);
      loadSub(this.value, isOriginal ? initSub : '', isOriginal ? initMore : '');
    });

    // เปลี่ยนหมวดรอง — ถ้ากลับมาค่าเดิมให้ restore หมวดย่อยด้วย
    subObject.addEventListener('change', function () {
      var isOriginal = initSub && String(this.value) === String(initSub);
      loadMore(this.value, isOriginal ? initMore : '');
    });

    // โหลดค่าเดิมตอน page load (update page)
    if (initCat && subObject.options.length <= 1) {
      loadSub(initCat, initSub, initMore);
    }
  }

  // -------------------
  // Radio: บุคคลธรรมดา / นิติบุคคล
  // -------------------
  var corporationRadios = document.querySelectorAll("input[name='corporation']");

  function toggleCorporation(val) {
    var corporate  = document.getElementById('corporate');
    var person     = document.getElementById('person');
    if (val === 'บุคคลธรรมดา') {
      person?.classList.remove('d-none');
      corporate?.classList.add('d-none');
    } else if (val === 'นิติบุคคล') {
      corporate?.classList.remove('d-none');
      person?.classList.add('d-none');
    } else {
      person?.classList.add('d-none');
      corporate?.classList.add('d-none');
    }
  }

  // [FIX] restore สถานะตอน page load (กรณีหน้า update มี radio checked อยู่แล้ว)
  var checkedRadio = document.querySelector("input[name='corporation']:checked");
  if (checkedRadio) toggleCorporation(checkedRadio.value);

  corporationRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      toggleCorporation(this.value);
    });
  });

  // -------------------
  // Product status → Harvest date
  // -------------------
  var productStatus = document.getElementById('productstatus');
  if(productStatus){
    // [FIX] แยก logic เป็น function เพื่อเรียกได้ทั้งตอน change และตอน page load
    function toggleHarvestDate(val) {
      var harvest = document.getElementById('harvest');
      var invalidFeedback = document.getElementById('invalid-feedback');
      var harvestDateInput = document.querySelector("[name='harvest_date']");
      // [FIX] เพิ่ม 'พร้อมเก็บ' — server-side (update.php) รองรับทั้งสองค่าแล้ว แต่ JS ไม่ได้แสดง harvest date
      var showHarvest = (val === 'เก็บเกี่ยว' || val === 'พร้อมเก็บ');
      if(showHarvest){
        harvest?.classList.remove('d-none');
        invalidFeedback?.classList.remove('d-none');
        harvestDateInput && (harvestDateInput.required = true);
      } else {
        harvest?.classList.add('d-none');
        invalidFeedback?.classList.add('d-none');
        harvestDateInput && (harvestDateInput.required = false);
      }
    }
    // [FIX] เรียกตอน page load เพื่อ restore สถานะหน้า update (มี value selected อยู่แล้ว)
    toggleHarvestDate(productStatus.value);
    productStatus.addEventListener('change', function(){
      toggleHarvestDate(this.value);
    });
  }

});

// -------------------
// Function hide invalid-feedback manually
// -------------------
function validatCharvest() {
  var invalidFeedback = document.getElementById('invalid-feedback');
  invalidFeedback?.classList.add('d-none');
}

// lenText
function lenText(ele, max, showClass) {
  var el = typeof ele === 'string' ? document.querySelector(ele) : ele;
  if (!el) return;
  var v = el.value || '';
  if (v.length > max) {
    el.value = v.substring(0, max);
    v = el.value;
  }
  var span = document.querySelector('.' + showClass);
  if (span) span.textContent = max - v.length;
}
window.lenText = lenText;

document.addEventListener('DOMContentLoaded', function() {
  var input = document.querySelector('input[name="business_details"]');
  if (!input) return;
  var max = 100;
  var showClass = 'maxlength';
  lenText(input, max, showClass);
  input.addEventListener('input', function() { lenText(this, max, showClass); });
});

// Bootstrap validation
(function () {
  'use strict'
  var forms = document.querySelectorAll('.needs-validation')
  Array.prototype.slice.call(forms)
  .forEach(function (form) {
    form.addEventListener('submit', function (event) {
      if (!form.checkValidity()) {
        event.preventDefault()
        event.stopPropagation()
      }
      form.classList.add('was-validated')
    }, false)
  })
})()

// checkPassword
document.addEventListener("DOMContentLoaded", () => {
  const passwordInput = document.getElementById("password");
  const confirmInput = document.getElementById("confirmPassword");
  const message = document.getElementById("message");

  if (!passwordInput || !confirmInput || !message) return;

  function checkPassword() {
    const password = passwordInput.value;
    const confirm = confirmInput.value;

    if (password.length === 0 && confirm.length === 0) {
      message.innerHTML = "";
      return false;
    }

    if (password.length < 8) {
      message.innerHTML = "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร ❌";
      message.style.color = "red";
      return false;
    }

    let strength = 0;
    if (/[A-Z]/.test(password)) strength++;
    if (/[a-z]/.test(password)) strength++;
    if (/[0-9]/.test(password)) strength++;
    if (/[^A-Za-z0-9]/.test(password)) strength++;

    if (strength === 1) {
      message.innerHTML = "รหัสผ่านไม่ปลอดภัย ❌";
      message.style.color = "red";
    } else if (strength === 2 || strength === 3) {
      message.innerHTML = "รหัสผ่านปานกลาง ⚠️";
      message.style.color = "orange";
    } else if (strength === 4) {
      message.innerHTML = "รหัสผ่านปลอดภัยสูง ✅";
      message.style.color = "green";
    }

    if (confirm.length > 0) {
      if (password !== confirm) {
        message.innerHTML = "รหัสผ่านไม่ตรงกัน ❌";
        message.style.color = "red";
        return false;
      } else if (strength >= 2) {
        message.innerHTML = "รหัสผ่านถูกต้อง ✅";
        message.style.color = "green";
        return true;
      }
    }

    return strength >= 2;
  }

  passwordInput.addEventListener("keyup", checkPassword);
  confirmInput.addEventListener("keyup", checkPassword);
});